<template>
    <div :class="containerStyles">
        <div class="flex flex-col items-center gap-2 px-4">
            <slot name="image">
                <div
                    class="w-16 h-16 bg-slate-200 dark:bg-slate-700 rounded-full flex justify-center items-center mb-5"
                    v-if="icon"
                >
                    <Icon :icon="icon" :width="30" :height="30" />
                </div>
            </slot>
            <slot name="content">
                <h5 class="text-slate-800 dark:text-slate-100 text-lg font-medium">
                    {{ title }}
                </h5>
                <p class="text-slate-500 dark:text-slate-400 text-sm mb-5">
                    {{ description }}
                </p>
            </slot>
            <slot name="action">
                <button
                    class="px-4 py-2.5 bg-white dark:bg-slate-800 hover:bg-slate-100 dark:hover:bg-slate-700 transition-colors rounded shadow dark:shadow-slate-900/50 border border-slate-200 dark:border-slate-700 items-center text-slate-800 dark:text-slate-100 text-sm font-medium"
                    @click.prevent="$emit('action')"
                    v-if="hasAction"
                >
                    {{ actionLabel }}
                </button>
            </slot>
        </div>
    </div>
</template>
<script setup>
import Icon from '@/components/ui/icon/icon.vue';
defineProps({
    containerStyles: { type: String, default: 'py-10' },
    imageName: { type: String, default: null },
    icon: { type: String, default: null },
    title: String,
    description: String,
    hasAction: { type: Boolean, default: true },
    actionLabel: String,
    showAnimation: { type: Boolean, default: true },
});
</script>
<style lang="scss" scoped>
svg.animated-arrow {
    margin: 0 auto;
    .draw-arrow {
        stroke-width: 3;
        stroke: #fd421d;
        fill: none;
        stroke-dasharray: 400;
        stroke-dashoffset: 400;
        animation-duration: 2s;
        animation-delay: 2s;
        animation-fill-mode: forwards;
        animation-name: draw;
        &.tail-1 {
            animation-delay: 2.5s;
        }
        &.tail-2 {
            animation-delay: 2.7s;
        }
    }
}
@keyframes draw {
    to {
        stroke-dashoffset: 0;
    }
}
</style>
